import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/cancel-operation-list',
      name: 'admin-cancel-operation-list',
      component: () => import(/* webpackChunkName: "page-admin-credit-management-cancel-operation-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "砍单账单列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "授信管理"
                                        },
                                        {
                                                  name: "砍单账单列表"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
